// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsAssigneeListBody = {
  poolId: string;
  eventId: string;
  stripNumber: number;
};

export type typeStripsAssigneeListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    members: {
      userId: string;
      displayName: string;
      initials: string;
      avatarUrl?: string | null;
      spotCount: number;
      isAtLimit: boolean;
    }[];
    maxSpotsPerMember?: number | null;
  };
};

export type typeStripsAssigneeListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsAssigneeListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsAssigneeListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsAssigneeListBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    stripNumber: { type: "integer" },
  },
  required: ["poolId", "eventId", "stripNumber"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsAssigneeList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsAssigneeListBody);
  }

  return async function postStripsAssigneeList(
    payload: typeStripsAssigneeListBody,
  ): Promise<
    typeStripsAssigneeListOutput200 | typeStripsAssigneeListOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsAssigneeList" failed before calling the network. #30ba1c3187bf`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#30ba1c3187bf" },
        },
        data: null,
      } as typeStripsAssigneeListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/assignee-list`,
      httpMethod: "POST",
      options,
    })) as typeStripsAssigneeListOutput200 | typeStripsAssigneeListOutput400;
  };
}
